// `cn` — composable class-name concatenation.
// Thin wrapper over clsx for component variants.

import { clsx, type ClassValue } from 'clsx';

export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
